/* eslint-disable import/prefer-default-export */
import axios from 'axios'

const { TOM_LOGS_API } = process.env




export const apiTomLogs = axios.create({
  baseURL: TOM_LOGS_API,
  withCredentials: true,
  timeout: 960000,
})
